import { createAction } from '@ngrx/store';

export const submittalEntrySidebarActions = {
  loadPage: createAction('[Submittal - Registry Entry Sidebar Component] Load Page'),
};
